import { serviceMaker, methods, api } from "@/http/index.js";

export const getCollectionList = () =>
  serviceMaker(`/collection`, methods.GET, api.NGB);
export const getClientsTemplate = () =>
  serviceMaker(`/clients/template`, methods.GET, api.NGB);
export const getClientServiceTemplate = () =>
  serviceMaker(`/collection/template`, methods.GET, api.NGB);
export const createCollectionTemplate = (data) =>
  serviceMaker(`/collection/create`, methods.POST, api.NGB, data);
export const createCollectionTrigger = (data) =>
  serviceMaker(`/collectiontrigger/create`, methods.POST, api.NGB, data);
export const getCollectionTriggers = (id) =>
  serviceMaker(`/collection/collectiontrigger/${id}`, methods.GET, api.NGB);
export const getCollectionScenarios = (id) =>
  serviceMaker(`/collection/collectionscenario/${id}`, methods.GET, api.NGB);
export const createCollectionScenerios = (data) =>
  serviceMaker(`/collectionscenario/create`, methods.POST, api.NGB, data);
export const getCollectionActions = () =>
  serviceMaker(`/collectionscenario/collection_actions`, methods.GET, api.NGB);
export const deleteCollection = (id) =>
  serviceMaker(`/collection/${id}`, methods.DELETE, api.NGB);
export const getCollectionById = (id) =>
  serviceMaker(`/collection/${id}`, methods.GET, api.NGB);
export const editCollection = (data) =>
  serviceMaker(`/collection/${data.id}`, methods.PUT, api.NGB, data.data);
export const deleteCollectionTrigger = (id) =>
  serviceMaker(`/collectiontrigger/${id}`, methods.DELETE, api.NGB);
export const deleteCollectionScenario = (id) =>
  serviceMaker(`/collectionscenario/${id}`, methods.DELETE, api.NGB);
export const editCollectionTrigger = (data) =>
  serviceMaker(`/collectiontrigger/${data.id}`, methods.PUT, api.NGB, data.data);
export const editCollectionScenario = (data) =>
  serviceMaker(`/collectionscenario/${data.id}`, methods.PUT, api.NGB, data.data);